import {
  Box,
  Grid2,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Typography,
} from "@mui/material";
import React from "react";
import { commonCss } from "../../../CssStyle/commonCss";
import {
  Done,
  BalanceOutlined,
  CodeOffOutlined,
  FiberManualRecord,
  HowToVote,
  InsertChart,
  PeopleAltOutlined,
  PieChartOutline,
  TaskAlt,
  WorkspacesRounded,
} from "@mui/icons-material";
// import aboutUsBg from "../../../Images/aboutUsBg.jpg";
// import cybersecurity from "../../../Images/Cybersecurity/cybersecurity.jpg";

const CyberSecurity = () => {
  return (
    <Grid2 container>
      <Grid2 container size={12} justifyContent={"center"}>
        <Grid2
          container
          size={12}
          sx={{ background: `url(/Images/aboutUsBg.jpg)`, backgroundSize: "cover" }}
          justifyContent={"center"}
        >
          <Grid2
            container
            size={{ xs: 12, md: 11, xl: 10 }}
            justifyContent={"center"}
            alignItems={"center"}
            mt={{ xs: "30%", sm: "20%", md: "15%", lg: "13%", xl: "8%" }}
            sx={{ p: "1rem", maxWidth: { xs: "auto", xl: "2000px" } }}
          >
            <Typography
              variant="h5"
              sx={{
                fontSize: { xs: "1.5rem", md: "2.5rem" },
                fontWeight: 600,
                lineHeight: "normal",
                mb: "1rem",
                color: commonCss.blue,
              }}
            >
              Cybersecurity Services
            </Typography>
            <Typography
              sx={{
                fontSize: { xs: "1rem", md: "1.1rem" },
                mb: "1rem",
                textAlign: "center",
                color: commonCss.darkGray,
              }}
            >
              we provide end-to-end cybersecurity services that help businesses
              of all sizes stay protected in an increasingly digital and
              threat-prone world. From proactive threat prevention to real-time
              monitoring and rapid incident response, we deliver tailored
              solutions that align with your business goals and compliance
              needs.
            </Typography>
          </Grid2>
        </Grid2>
        <Grid2
          container
          size={12}
          // sx={{ background: `url(${aboutUsBg})`, backgroundSize: "cover" }}
          justifyContent={"center"}
        >
          <Grid2
            size={{ xs: 12, md: 11, xl: 10 }}
            sx={{
              p: { xs: "1rem", md: "3rem" },
              maxWidth: { xs: "auto", xl: "2000px" },
            }}
          >
            <Box
              sx={{
                width: "100%",
                display: "flex",
                flexDirection: "column",
                gap: "2rem",
              }}
            >
              <Box
                component={"img"}
                src={"/Images/Cybersecurity/cybersecurity.jpg"}
                alt="Sharepoint"
                sx={{
                  borderRadius: "15px",
                  width: "100%",
                  height: { xs: "50vh", md: "70vh" },
                  objectFit: "cover",
                }}
              />
            </Box>
          </Grid2>
        </Grid2>
        <Grid2
          container
          size={12}
          // sx={{ background: `url(${aboutUsBg})`, backgroundSize: "cover" }}
          justifyContent={"center"}
        >
          <Grid2
            container
            size={{ xs: 12, md: 11, xl: 10 }}
            justifyContent={"center"}
            spacing={{ xs: "1rem", md: "2rem" }}
            sx={{
              p: { xs: "1rem", md: "3rem" },
              maxWidth: { xs: "auto", xl: "2000px" },
            }}
          >
            <Grid2 size={{ xs: 12, md: 6 }}>
              <Box
                sx={{
                  display: "flex",
                  gap: { xs: "1rem", md: "2rem" },
                  width: "100%",
                }}
              >
                <TaskAlt
                  sx={{ color: commonCss.orange, fontSize: "2rem", mt: 1 }}
                />
                <Box>
                  <Typography
                    variant="h4"
                    sx={{
                      fontSize: { xs: "1.5rem", md: "2rem" },
                      fontWeight: 600,
                      lineHeight: "normal",
                    }}
                  >
                    Cybersecurity Risk Assessment & Gap Analysis
                  </Typography>

                  <Typography
                    sx={{
                      fontSize: { xs: "1rem", md: "1.1rem" },
                      fontSize: { xs: "0.8rem", md: "1rem" },
                      mt: "1rem",
                      color: commonCss.darkGray,
                    }}
                  >
                    We begin by evaluating your existing security environment,
                    identifying vulnerabilities, and mapping them against
                    industry standards and best practices. Our experts perform a
                    comprehensive gap analysis to highlight areas of risk and
                    develop a roadmap to improve your organization’s overall
                    security posture.
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: "1.1rem",
                      fontWeight: 450,
                      fontFamily: "inherit",
                      mt: 2,
                      color: commonCss.darkGray,
                    }}
                  >
                    Deliverables:
                  </Typography>
                  <List
                    sx={{
                      "& .MuiListItemText-primary": {
                        fontFamily: "Roboto, sans-serif",
                        fontSize: "1rem",
                        fontWeight: "normal",
                        color: commonCss.darkGray,
                      },
                      display: "flex",
                      columnGap: "1rem",
                      rowGap: "0.5rem",
                      flexWrap: "wrap",
                      width: "100%",
                      //    mt:"1rem"
                    }}
                  >
                    <ListItem sx={{ p: 0, width: { xs: "100%" } }}>
                      <ListItemIcon>
                        <Done />
                      </ListItemIcon>
                      <ListItemText>Security posture report</ListItemText>
                    </ListItem>

                    <ListItem sx={{ p: 0, width: { xs: "100%" } }}>
                      <ListItemIcon>
                        <Done />
                      </ListItemIcon>
                      <ListItemText>Risk matrix and scoring</ListItemText>
                    </ListItem>

                    <ListItem sx={{ p: 0, width: { xs: "100%" } }}>
                      <ListItemIcon>
                        <Done />
                      </ListItemIcon>
                      <ListItemText>
                        Recommendations and remediation plan
                      </ListItemText>
                    </ListItem>
                    <ListItem sx={{ p: 0, width: { xs: "100%" } }}>
                      <ListItemIcon>
                        <Done />
                      </ListItemIcon>
                      <ListItemText>
                        Compliance readiness check (GDPR, HIPAA, ISO 27001,
                        etc.)
                      </ListItemText>
                    </ListItem>
                  </List>
                </Box>
              </Box>
            </Grid2>
            <Grid2 size={{ xs: 12, md: 6 }}>
              <Box
                sx={{
                  display: "flex",
                  gap: { xs: "1rem", md: "2rem" },
                  width: "100%",
                }}
              >
                <TaskAlt
                  sx={{ color: commonCss.orange, fontSize: "2rem", mt: 1 }}
                />
                <Box>
                  <Typography
                    variant="h4"
                    sx={{
                      fontSize: { xs: "1.5rem", md: "2rem" },
                      fontWeight: 600,
                      lineHeight: "normal",
                    }}
                  >
                    Managed Security Services (MSS)
                  </Typography>

                  <Typography
                    sx={{
                      fontSize: { xs: "1rem", md: "1.1rem" },
                      fontSize: { xs: "0.8rem", md: "1rem" },
                      mt: "1rem",
                      color: commonCss.darkGray,
                    }}
                  >
                    Our 24/7 Managed Security Services provide real-time threat
                    detection, analysis, and response using advanced Security
                    Information and Event Management (SIEM) systems, threat
                    intelligence, and automated workflows. Stay protected
                    without managing everything in-house.
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: "1.1rem",
                      fontWeight: 450,
                      fontFamily: "inherit",
                      mt: 2,
                      color: commonCss.darkGray,
                    }}
                  >
                    Key Features:
                  </Typography>
                  <List
                    sx={{
                      "& .MuiListItemText-primary": {
                        fontFamily: "Roboto, sans-serif",
                        fontSize: "1rem",
                        fontWeight: "normal",
                        color: commonCss.darkGray,
                      },
                      display: "flex",
                      columnGap: "1rem",
                      rowGap: "0.5rem",
                      flexWrap: "wrap",
                      width: "100%",
                      //    mt:"1rem"
                    }}
                  >
                    <ListItem sx={{ p: 0, width: { xs: "100%" } }}>
                      <ListItemIcon>
                        <Done />
                      </ListItemIcon>
                      <ListItemText>
                        24x7 Security Operations Center (SOC)
                      </ListItemText>
                    </ListItem>

                    <ListItem sx={{ p: 0, width: { xs: "100%" } }}>
                      <ListItemIcon>
                        <Done />
                      </ListItemIcon>
                      <ListItemText>
                        Continuous monitoring and alerting
                      </ListItemText>
                    </ListItem>

                    <ListItem sx={{ p: 0, width: { xs: "100%" } }}>
                      <ListItemIcon>
                        <Done />
                      </ListItemIcon>
                      <ListItemText>
                        Incident response and forensic analysis
                      </ListItemText>
                    </ListItem>
                    <ListItem sx={{ p: 0, width: { xs: "100%" } }}>
                      <ListItemIcon>
                        <Done />
                      </ListItemIcon>
                      <ListItemText>
                        Threat intelligence and behavior analytics
                      </ListItemText>
                    </ListItem>
                  </List>
                </Box>
              </Box>
            </Grid2>
            <Grid2 size={{ xs: 12, md: 6 }}>
              <Box
                sx={{
                  display: "flex",
                  gap: { xs: "1rem", md: "2rem" },
                  width: "100%",
                }}
              >
                <TaskAlt
                  sx={{ color: commonCss.orange, fontSize: "2rem", mt: 1 }}
                />
                <Box>
                  <Typography
                    variant="h4"
                    sx={{
                      fontSize: { xs: "1.5rem", md: "2rem" },
                      fontWeight: 600,
                      lineHeight: "normal",
                    }}
                  >
                    Network and Infrastructure Security
                  </Typography>

                  <Typography
                    sx={{
                      fontSize: { xs: "1rem", md: "1.1rem" },
                      fontSize: { xs: "0.8rem", md: "1rem" },
                      mt: "1rem",
                      color: commonCss.darkGray,
                    }}
                  >
                    We fortify your digital perimeter by securing all entry
                    points into your network, including routers, switches,
                    firewalls, and cloud infrastructure. We implement
                    enterprise-grade firewall policies, Zero Trust models, and
                    segmentation to block lateral movement of threats.
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: "1.1rem",
                      fontWeight: 450,
                      fontFamily: "inherit",
                      mt: 2,
                      color: commonCss.darkGray,
                    }}
                  >
                    Solutions Offered:
                  </Typography>
                  <List
                    sx={{
                      "& .MuiListItemText-primary": {
                        fontFamily: "Roboto, sans-serif",
                        fontSize: "1rem",
                        fontWeight: "normal",
                        color: commonCss.darkGray,
                      },
                      display: "flex",
                      columnGap: "1rem",
                      rowGap: "0.5rem",
                      flexWrap: "wrap",
                      width: "100%",
                      //    mt:"1rem"
                    }}
                  >
                    <ListItem sx={{ p: 0, width: { xs: "100%" } }}>
                      <ListItemIcon>
                        <Done />
                      </ListItemIcon>
                      <ListItemText>Next-gen firewalls (NGFW)</ListItemText>
                    </ListItem>

                    <ListItem sx={{ p: 0, width: { xs: "100%" } }}>
                      <ListItemIcon>
                        <Done />
                      </ListItemIcon>
                      <ListItemText>
                        Intrusion Detection & Prevention (IDS/IPS)
                      </ListItemText>
                    </ListItem>

                    <ListItem sx={{ p: 0, width: { xs: "100%" } }}>
                      <ListItemIcon>
                        <Done />
                      </ListItemIcon>
                      <ListItemText>VPN and secure remote access</ListItemText>
                    </ListItem>
                    <ListItem sx={{ p: 0, width: { xs: "100%" } }}>
                      <ListItemIcon>
                        <Done />
                      </ListItemIcon>
                      <ListItemText>
                        Network segmentation and Zero Trust architecture
                      </ListItemText>
                    </ListItem>
                  </List>
                </Box>
              </Box>
            </Grid2>
            <Grid2 size={{ xs: 12, md: 6 }}>
              <Box
                sx={{
                  display: "flex",
                  gap: { xs: "1rem", md: "2rem" },
                  width: "100%",
                }}
              >
                <TaskAlt
                  sx={{ color: commonCss.orange, fontSize: "2rem", mt: 1 }}
                />
                <Box>
                  <Typography
                    variant="h4"
                    sx={{
                      fontSize: { xs: "1.5rem", md: "2rem" },
                      fontWeight: 600,
                      lineHeight: "normal",
                    }}
                  >
                    Cloud Security Services
                  </Typography>

                  <Typography
                    sx={{
                      fontSize: { xs: "1rem", md: "1.1rem" },
                      fontSize: { xs: "0.8rem", md: "1rem" },
                      mt: "1rem",
                      color: commonCss.darkGray,
                    }}
                  >
                    Whether you're on AWS, Azure, GCP, or a hybrid cloud
                    environment, we help secure your cloud assets and ensure
                    continuous compliance. Our services include identity and
                    access management, cloud workload protection, and cloud
                    security posture management (CSPM).
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: "1.1rem",
                      fontWeight: 450,
                      fontFamily: "inherit",
                      mt: 2,
                      color: commonCss.darkGray,
                    }}
                  >
                    Coverage Includes:
                  </Typography>
                  <List
                    sx={{
                      "& .MuiListItemText-primary": {
                        fontFamily: "Roboto, sans-serif",
                        fontSize: "1rem",
                        fontWeight: "normal",
                        color: commonCss.darkGray,
                      },
                      display: "flex",
                      columnGap: "1rem",
                      rowGap: "0.5rem",
                      flexWrap: "wrap",
                      width: "100%",
                      //    mt:"1rem"
                    }}
                  >
                    <ListItem sx={{ p: 0, width: { xs: "100%" } }}>
                      <ListItemIcon>
                        <Done />
                      </ListItemIcon>
                      <ListItemText>
                        Secure cloud architecture review
                      </ListItemText>
                    </ListItem>

                    <ListItem sx={{ p: 0, width: { xs: "100%" } }}>
                      <ListItemIcon>
                        <Done />
                      </ListItemIcon>
                      <ListItemText>Misconfiguration audits</ListItemText>
                    </ListItem>

                    <ListItem sx={{ p: 0, width: { xs: "100%" } }}>
                      <ListItemIcon>
                        <Done />
                      </ListItemIcon>
                      <ListItemText>
                        Cloud data encryption and access control
                      </ListItemText>
                    </ListItem>
                    <ListItem sx={{ p: 0, width: { xs: "100%" } }}>
                      <ListItemIcon>
                        <Done />
                      </ListItemIcon>
                      <ListItemText>
                        Cloud-native threat detection and response
                      </ListItemText>
                    </ListItem>
                  </List>
                </Box>
              </Box>
            </Grid2>
            <Grid2 size={{ xs: 12, md: 6 }}>
              <Box
                sx={{
                  display: "flex",
                  gap: { xs: "1rem", md: "2rem" },
                  width: "100%",
                }}
              >
                <TaskAlt
                  sx={{ color: commonCss.orange, fontSize: "2rem", mt: 1 }}
                />
                <Box>
                  <Typography
                    variant="h4"
                    sx={{
                      fontSize: { xs: "1.5rem", md: "2rem" },
                      fontWeight: 600,
                      lineHeight: "normal",
                    }}
                  >
                    Endpoint Security
                  </Typography>

                  <Typography
                    sx={{
                      fontSize: { xs: "1rem", md: "1.1rem" },
                      fontSize: { xs: "0.8rem", md: "1rem" },
                      mt: "1rem",
                      color: commonCss.darkGray,
                    }}
                  >
                    Endpoints are the front lines of cyber defense. We deploy
                    advanced Endpoint Detection and Response (EDR), antivirus,
                    and mobile device management (MDM) solutions to prevent,
                    detect, and respond to attacks across your devices.
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: "1.1rem",
                      fontWeight: 450,
                      fontFamily: "inherit",
                      mt: 2,
                      color: commonCss.darkGray,
                    }}
                  >
                    Capabilities:
                  </Typography>
                  <List
                    sx={{
                      "& .MuiListItemText-primary": {
                        fontFamily: "Roboto, sans-serif",
                        fontSize: "1rem",
                        fontWeight: "normal",
                        color: commonCss.darkGray,
                      },
                      display: "flex",
                      columnGap: "1rem",
                      rowGap: "0.5rem",
                      flexWrap: "wrap",
                      width: "100%",
                      //    mt:"1rem"
                    }}
                  >
                    <ListItem sx={{ p: 0, width: { xs: "100%" } }}>
                      <ListItemIcon>
                        <Done />
                      </ListItemIcon>
                      <ListItemText>
                        Centralized endpoint visibility
                      </ListItemText>
                    </ListItem>

                    <ListItem sx={{ p: 0, width: { xs: "100%" } }}>
                      <ListItemIcon>
                        <Done />
                      </ListItemIcon>
                      <ListItemText>Real-time malware detection</ListItemText>
                    </ListItem>

                    <ListItem sx={{ p: 0, width: { xs: "100%" } }}>
                      <ListItemIcon>
                        <Done />
                      </ListItemIcon>
                      <ListItemText>Automated threat response</ListItemText>
                    </ListItem>
                    <ListItem sx={{ p: 0, width: { xs: "100%" } }}>
                      <ListItemIcon>
                        <Done />
                      </ListItemIcon>
                      <ListItemText>
                        Policy enforcement for remote users
                      </ListItemText>
                    </ListItem>
                  </List>
                </Box>
              </Box>
            </Grid2>
            <Grid2 size={{ xs: 12, md: 6 }}>
              <Box
                sx={{
                  display: "flex",
                  gap: { xs: "1rem", md: "2rem" },
                  width: "100%",
                }}
              >
                <TaskAlt
                  sx={{ color: commonCss.orange, fontSize: "2rem", mt: 1 }}
                />
                <Box>
                  <Typography
                    variant="h4"
                    sx={{
                      fontSize: { xs: "1.5rem", md: "2rem" },
                      fontWeight: 600,
                      lineHeight: "normal",
                    }}
                  >
                    Identity and Access Management (IAM)
                  </Typography>

                  <Typography
                    sx={{
                      fontSize: { xs: "1rem", md: "1.1rem" },
                      fontSize: { xs: "0.8rem", md: "1rem" },
                      mt: "1rem",
                      color: commonCss.darkGray,
                    }}
                  >
                    Control who can access what across your organization. We
                    help you implement robust IAM policies, ensuring that only
                    authorized personnel access sensitive data and applications.
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: "1.1rem",
                      fontWeight: 450,
                      fontFamily: "inherit",
                      mt: 2,
                      color: commonCss.darkGray,
                    }}
                  >
                    Services:
                  </Typography>
                  <List
                    sx={{
                      "& .MuiListItemText-primary": {
                        fontFamily: "Roboto, sans-serif",
                        fontSize: "1rem",
                        fontWeight: "normal",
                        color: commonCss.darkGray,
                      },
                      display: "flex",
                      columnGap: "1rem",
                      rowGap: "0.5rem",
                      flexWrap: "wrap",
                      width: "100%",
                      //    mt:"1rem"
                    }}
                  >
                    <ListItem sx={{ p: 0, width: { xs: "100%" } }}>
                      <ListItemIcon>
                        <Done />
                      </ListItemIcon>
                      <ListItemText>
                        Single Sign-On (SSO) and Multi-Factor Authentication
                        (MFA)
                      </ListItemText>
                    </ListItem>

                    <ListItem sx={{ p: 0, width: { xs: "100%" } }}>
                      <ListItemIcon>
                        <Done />
                      </ListItemIcon>
                      <ListItemText>
                        Role-based Access Control (RBAC)
                      </ListItemText>
                    </ListItem>

                    <ListItem sx={{ p: 0, width: { xs: "100%" } }}>
                      <ListItemIcon>
                        <Done />
                      </ListItemIcon>
                      <ListItemText>
                        Privileged Access Management (PAM)
                      </ListItemText>
                    </ListItem>
                    <ListItem sx={{ p: 0, width: { xs: "100%" } }}>
                      <ListItemIcon>
                        <Done />
                      </ListItemIcon>
                      <ListItemText>Identity lifecycle management</ListItemText>
                    </ListItem>
                  </List>
                </Box>
              </Box>
            </Grid2>
            <Grid2 size={{ xs: 12, md: 6 }}>
              <Box
                sx={{
                  display: "flex",
                  gap: { xs: "1rem", md: "2rem" },
                  width: "100%",
                }}
              >
                <TaskAlt
                  sx={{ color: commonCss.orange, fontSize: "2rem", mt: 1 }}
                />
                <Box>
                  <Typography
                    variant="h4"
                    sx={{
                      fontSize: { xs: "1.5rem", md: "2rem" },
                      fontWeight: 600,
                      lineHeight: "normal",
                    }}
                  >
                    Data Protection and Encryption
                  </Typography>

                  <Typography
                    sx={{
                      fontSize: { xs: "1rem", md: "1.1rem" },
                      fontSize: { xs: "0.8rem", md: "1rem" },
                      mt: "1rem",
                      color: commonCss.darkGray,
                    }}
                  >
                    We help you secure sensitive information at rest, in
                    transit, and during use. Our data security services ensure
                    regulatory compliance while protecting your organization
                    from leaks, breaches, and unauthorized access.
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: "1.1rem",
                      fontWeight: 450,
                      fontFamily: "inherit",
                      mt: 2,
                      color: commonCss.darkGray,
                    }}
                  >
                    Tools and Techniques:
                  </Typography>
                  <List
                    sx={{
                      "& .MuiListItemText-primary": {
                        fontFamily: "Roboto, sans-serif",
                        fontSize: "1rem",
                        fontWeight: "normal",
                        color: commonCss.darkGray,
                      },
                      display: "flex",
                      columnGap: "1rem",
                      rowGap: "0.5rem",
                      flexWrap: "wrap",
                      width: "100%",
                      //    mt:"1rem"
                    }}
                  >
                    <ListItem sx={{ p: 0, width: { xs: "100%" } }}>
                      <ListItemIcon>
                        <Done />
                      </ListItemIcon>
                      <ListItemText>Data Loss Prevention (DLP)</ListItemText>
                    </ListItem>

                    <ListItem sx={{ p: 0, width: { xs: "100%" } }}>
                      <ListItemIcon>
                        <Done />
                      </ListItemIcon>
                      <ListItemText>
                        End-to-end encryption solutions
                      </ListItemText>
                    </ListItem>

                    <ListItem sx={{ p: 0, width: { xs: "100%" } }}>
                      <ListItemIcon>
                        <Done />
                      </ListItemIcon>
                      <ListItemText>
                        Secure backups and disaster recovery
                      </ListItemText>
                    </ListItem>
                    <ListItem sx={{ p: 0, width: { xs: "100%" } }}>
                      <ListItemIcon>
                        <Done />
                      </ListItemIcon>
                      <ListItemText>
                        Compliance (HIPAA, PCI-DSS, GDPR)
                      </ListItemText>
                    </ListItem>
                  </List>
                </Box>
              </Box>
            </Grid2>
            <Grid2 size={{ xs: 12, md: 6 }}>
              <Box
                sx={{
                  display: "flex",
                  gap: { xs: "1rem", md: "2rem" },
                  width: "100%",
                }}
              >
                <TaskAlt
                  sx={{ color: commonCss.orange, fontSize: "2rem", mt: 1 }}
                />
                <Box>
                  <Typography
                    variant="h4"
                    sx={{
                      fontSize: { xs: "1.5rem", md: "2rem" },
                      fontWeight: 600,
                      lineHeight: "normal",
                    }}
                  >
                    Incident Response and Digital Forensics
                  </Typography>

                  <Typography
                    sx={{
                      fontSize: { xs: "1rem", md: "1.1rem" },
                      fontSize: { xs: "0.8rem", md: "1rem" },
                      mt: "1rem",
                      color: commonCss.darkGray,
                    }}
                  >
                    If your organization is under attack or has suffered a
                    breach, our rapid response team is ready to contain the
                    threat, investigate the source, and support your recovery
                    process.
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: "1.1rem",
                      fontWeight: 450,
                      fontFamily: "inherit",
                      mt: 2,
                      color: commonCss.darkGray,
                    }}
                  >
                    Incident Response Services:
                  </Typography>
                  <List
                    sx={{
                      "& .MuiListItemText-primary": {
                        fontFamily: "Roboto, sans-serif",
                        fontSize: "1rem",
                        fontWeight: "normal",
                        color: commonCss.darkGray,
                      },
                      display: "flex",
                      columnGap: "1rem",
                      rowGap: "0.5rem",
                      flexWrap: "wrap",
                      width: "100%",
                      //    mt:"1rem"
                    }}
                  >
                    <ListItem sx={{ p: 0, width: { xs: "100%" } }}>
                      <ListItemIcon>
                        <Done />
                      </ListItemIcon>
                      <ListItemText>
                        Breach detection and containment
                      </ListItemText>
                    </ListItem>

                    <ListItem sx={{ p: 0, width: { xs: "100%" } }}>
                      <ListItemIcon>
                        <Done />
                      </ListItemIcon>
                      <ListItemText>Root cause analysis</ListItemText>
                    </ListItem>

                    <ListItem sx={{ p: 0, width: { xs: "100%" } }}>
                      <ListItemIcon>
                        <Done />
                      </ListItemIcon>
                      <ListItemText>Threat neutralization</ListItemText>
                    </ListItem>
                    <ListItem sx={{ p: 0, width: { xs: "100%" } }}>
                      <ListItemIcon>
                        <Done />
                      </ListItemIcon>
                      <ListItemText>
                        Legal and regulatory reporting assistance
                      </ListItemText>
                    </ListItem>
                  </List>
                </Box>
              </Box>
            </Grid2>
            <Grid2 size={{ xs: 12, md: 6 }}>
              <Box
                sx={{
                  display: "flex",
                  gap: { xs: "1rem", md: "2rem" },
                  width: "100%",
                }}
              >
                <TaskAlt
                  sx={{ color: commonCss.orange, fontSize: "2rem", mt: 1 }}
                />
                <Box>
                  <Typography
                    variant="h4"
                    sx={{
                      fontSize: { xs: "1.5rem", md: "2rem" },
                      fontWeight: 600,
                      lineHeight: "normal",
                    }}
                  >
                    Security Awareness & Training
                  </Typography>

                  <Typography
                    sx={{
                      fontSize: { xs: "1rem", md: "1.1rem" },
                      fontSize: { xs: "0.8rem", md: "1rem" },
                      mt: "1rem",
                      color: commonCss.darkGray,
                    }}
                  >
                    Humans are often the weakest link in cybersecurity. Our
                    interactive, role-based training programs help employees
                    recognize threats like phishing, ransomware, and insider
                    risks — turning them into your strongest defense.
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: "1.1rem",
                      fontWeight: 450,
                      fontFamily: "inherit",
                      mt: 2,
                      color: commonCss.darkGray,
                    }}
                  >
                    Training Options:
                  </Typography>
                  <List
                    sx={{
                      "& .MuiListItemText-primary": {
                        fontFamily: "Roboto, sans-serif",
                        fontSize: "1rem",
                        fontWeight: "normal",
                        color: commonCss.darkGray,
                      },
                      display: "flex",
                      columnGap: "1rem",
                      rowGap: "0.5rem",
                      flexWrap: "wrap",
                      width: "100%",
                      //    mt:"1rem"
                    }}
                  >
                    <ListItem sx={{ p: 0, width: { xs: "100%" } }}>
                      <ListItemIcon>
                        <Done />
                      </ListItemIcon>
                      <ListItemText>
                        Phishing simulation and testing
                      </ListItemText>
                    </ListItem>

                    <ListItem sx={{ p: 0, width: { xs: "100%" } }}>
                      <ListItemIcon>
                        <Done />
                      </ListItemIcon>
                      <ListItemText>
                        On-demand video training modules
                      </ListItemText>
                    </ListItem>

                    <ListItem sx={{ p: 0, width: { xs: "100%" } }}>
                      <ListItemIcon>
                        <Done />
                      </ListItemIcon>
                      <ListItemText>
                        Security policies and compliance workshops
                      </ListItemText>
                    </ListItem>
                    <ListItem sx={{ p: 0, width: { xs: "100%" } }}>
                      <ListItemIcon>
                        <Done />
                      </ListItemIcon>
                      <ListItemText>Project progress reports</ListItemText>
                    </ListItem>
                    <ListItem sx={{ p: 0, width: { xs: "100%" } }}>
                      <ListItemIcon>
                        <Done />
                      </ListItemIcon>
                      <ListItemText>
                        Executive and IT staff training
                      </ListItemText>
                    </ListItem>
                  </List>
                </Box>
              </Box>
            </Grid2>
          </Grid2>
        </Grid2>
      </Grid2>
    </Grid2>
  );
};

export default CyberSecurity;
